import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "side-menu-sub-item__inner" }
const _hoisted_2 = { class: "side-menu-sub-item__txt" }
const _hoisted_3 = {
  key: 0,
  class: "side-menu-sub-item__contents"
}

import { ref, withDefaults } from "vue";
import {
  mapModifires,
  type typeModifires,
  mergeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  text?: string;
  opend?: boolean;
  alone?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'side-menu-sub-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    text: {},
    opend: { type: Boolean, default: false },
    alone: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const isOpend = ref<boolean>(props.opend);

const componentClass = () =>
  mapModifires(
    "side-menu-sub-item",
    mergeModifires(props.modifires, isOpend.value && "opend")
  );

const toggle = () => {
  isOpend.value = !isOpend.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: _normalizeClass(["side-menu-sub-item__btn", { 'side-menu-sub-item__btn_alone': _ctx.alone }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggle()), ["self"]))
      }, [
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "text")
        ])
      ], 2)
    ]),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})